import styled from "@emotion/styled"

export default styled.div({

}, ({ height }) => ({
    height
}))
